module.exports = `
  select
    order_id,
    sum(total_amount) as amount  
  from avocado.data_payment
  where order_id = $1 and lower(payment_method) = 'credit'
  group by 1
`
